import './index.css';
import { bootstrapApp } from './bootstrap/bootstrapApp';

bootstrapApp();
